module.exports = __webpack_public_path__ + "assets/undraw_wandering_mind_0mkm.svg";